@if (disabled) {
  <div class="tw:flex tw:items-center tw:flex-wrap">
    <!-- <cf-icon color="raven-40" icon="clock" class="tw:me-1"></cf-icon> -->
    <svg cfIcon="clock" class="tw:text-raven-40 tw:mr-1"></svg>
    @for (duration of availableDurations(); track $index; let last = $last) {
      <span class="tw:text-gray-70 tw:text-sm tw:ms-1">
        {{ duration | duration }}
      </span>
      <span class="tw:text-gray-70 tw:text-sm tw:ms-1">
        {{ last ? "mins" : "/" }}
      </span>
    }
  </div>
} @else {
  @if (availableDurations().length < 4 || !switchToDropdown) {
    <mat-button-toggle-group
      [(ngModel)]="_duration"
      aria-label="Duration"
      [ngClass]="toggleType"
      (change)="emitDurationChange.emit(minutes)"
    >
      @if (notFit) {
        <svg
          cfIcon="chevron_down"
          class="tw:text-blue-50 tw:cursor-pointer tw:rotate-90"
          (click)="moveTab('left'); $event.preventDefault(); $event.stopPropagation()"
        ></svg>
      }

      <div class="wrapper" #buttonGroupWrapper [class.tw:mx-6]="notFit">
        @for (duration of availableDurations(); track $index; let i = $index; let last = $last) {
          <mat-button-toggle
            [id]="buttonToggle.checked ? currentCheckedId : ''"
            [disableRipple]="true"
            [value]="duration"
            #buttonToggle
            (click)="$event.preventDefault(); $event.stopPropagation()"
          >
            <span class="tw:font-medium tw:text-base"
              >{{ duration | duration }}
              @if ((cutMin && buttonToggle.checked) || !cutMin) {
                {{ "duration_mins" | translate }}
              }
            </span>
          </mat-button-toggle>
        }
      </div>

      @if (notFit) {
        <svg
          cfIcon="chevron_down"
          class="tw:text-blue-50 tw:cursor-pointer tw:-rotate-90"
          (click)="moveTab('right'); $event.preventDefault(); $event.stopPropagation()"
        ></svg>
      }
    </mat-button-toggle-group>
  } @else {
    <cf-select-new
      (click)="$event.preventDefault(); $event.stopPropagation()"
      [(ngModel)]="_duration"
      [provider]="durationProvider"
      (ngModelChange)="durationChange($event)"
      [optionTemplate]="selectTmp"
      [labelTemplate]="selectTmp"
    >
      <ng-template #selectTmp let-item="item">
        {{ item.label | duration }} {{ "duration_mins" | translate }}
      </ng-template>
    </cf-select-new>
  }
}
